import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { MonthTotalsMessageProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import { StaticInfoMessage } from "components/common";
import MonthTotalReplacementList from "./_partial/monthTotalReplacementList";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

// One message at a time, escalating Info → Warning → Danger, so the grid never has more than one banner above it.
const MonthTotalsMessage: React.FC<MonthTotalsMessageProps> = (props) => {
  const { replacements, issues } = props;

  if (issues.length > 0) {
    return (
      <StaticInfoMessage
        displayType={StyleEnums.DisplayType.Danger}
        surface="background"
        fullWidth
        header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.MonthTotalsIssuesTitle)}
      >
        <ul>
          {issues.map((issue) => (
            <li key={issue}>{issue}</li>
          ))}
        </ul>
      </StaticInfoMessage>
    );
  }

  if (replacements.length > 0) {
    return (
      <StaticInfoMessage
        displayType={StyleEnums.DisplayType.Warning}
        surface="background"
        fullWidth
        header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.MonthTotalsReplaceTitle)}
      >
        <MonthTotalReplacementList replacements={replacements} />
      </StaticInfoMessage>
    );
  }

  return (
    <StaticInfoMessage displayType={StyleEnums.DisplayType.Info} surface="background" fullWidth>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.MonthTotalsInfo)}
    </StaticInfoMessage>
  );
};

export default MonthTotalsMessage;
